export const DEFAULT_API_VERSION = '3.0';
